import { useLocation } from "react-router-dom";
import Chat, { Bubble, useMessages } from "@chatui/core";
import "@chatui/core/dist/index.css";

export default function ChatPage() {
  const location = useLocation();
  const { messages, appendMsg } = useMessages([]);

  async function handleSend(type, val) {
    if (type === "text" && val.trim()) {
      appendMsg({
        type: "text",
        content: { text: val },
        position: "right",
      });

      try {
        const { user_timezone, user_location, auth_result } = location.state || {}
        const response = await fetch("https://ai.ziea.net/api/chat", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + auth_result.id_token,
          },
          body: JSON.stringify({
            timezone: user_timezone,
            location: user_location,
            data: {
              input: val,
            },
          }),
        });

        const res = await response.json();
        const goals = JSON.stringify(res.data.goals, null, 2);
        const schedules = JSON.stringify(res.data.schedules, null, 2);
        const content = `${res.data.output}\n\n <GOALS>: ${goals}\n<SCHEDULES>: ${schedules}`

        appendMsg({
          type: "text",
          content: { text: content || "Received the message." },
          position: "left",
        });
      } catch (err) {
        appendMsg({
          type: "text",
          content: { text: "The request failed. Please try again later." },
          position: "left",
        });
        console.error("The request error:", err);
      }
    }
  }

  function renderMessageContent(msg) {
    const { type, content } = msg;
    switch (type) {
      case "text":
        return <Bubble content={content.text} />;
      default:
        return null;
    }
  }

  return (
    <Chat
      navbar={{ title: "ZIEA Assistant" }}
      messages={messages}
      renderMessageContent={renderMessageContent}
      onSend={handleSend}
    />
  );
}
